import React, { Fragment } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Tweet } from 'react-twitter-widgets';
import { getTwitterIDFromUrl } from 'services/data-utils';

export default function TweetList({ tweets }) {
  if (!tweets.size) return null;

  return (
    <Fragment>
      {tweets.map(tweet => {
        const tweetId = getTwitterIDFromUrl(tweet);
        if (!tweetId) return null;
        return (
          <Tweet
            key={tweetId}
            tweetId={tweetId}
            options={{ align: 'center', conversation: 'none' }}
          />
        );
      })}
    </Fragment>
  );
}

TweetList.propTypes = {
  tweets: ImmutablePropTypes.list.isRequired
};



// WEBPACK FOOTER //
// ./src/components/TweetList/TweetList.js